import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';

// Utility function to check if JWT token is expired
const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp < currentTime;
  } catch (error) {
    console.error('Error parsing token:', error);
    return true;
  }
};

const AdminApp = () => {
  const [adminToken, setAdminToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if admin is already logged in
    const storedToken = localStorage.getItem('admin_token');
    if (storedToken) {
      console.log('🔍 Found stored admin token, checking expiration...');
      if (isTokenExpired(storedToken)) {
        console.log('❌ Stored admin token is expired, removing from localStorage');
        localStorage.removeItem('admin_token');
        setAdminToken(null);
      } else {
        console.log('✅ Stored admin token is valid');
        setAdminToken(storedToken);
      }
    } else {
      console.log('🔍 No stored admin token found');
    }
    setLoading(false);
  }, []);

  const handleAdminLogin = (token) => {
    console.log('✅ Admin login successful, storing token');
    localStorage.setItem('admin_token', token);
    setAdminToken(token);
  };

  const handleAdminLogout = () => {
    console.log('🚪 Admin logout - removing token');
    localStorage.removeItem('admin_token');
    setAdminToken(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center">
        <div className="text-teal-400">Loading...</div>
      </div>
    );
  }

  if (!adminToken) {
    return <AdminLogin onAdminLogin={handleAdminLogin} />;
  }

  return <AdminPanel adminToken={adminToken} onLogout={handleAdminLogout} />;
};

export default AdminApp;